angular.module('gym.access_control').factory('AccessControl', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var params;
  params = $rootScope.toParams;
  return Restangular.one('gyms', params.gymId).all('access_control');
}]);
